import React from "react"
import { Grid } from "@chakra-ui/react"

import { useCore } from "@hooks/useCore"
import { ArticleGridItemDesktop, ArticleGridItemMobile, ArticleGridItemProps } from "./ArticleGridItem"
import { Box } from "@chakra-ui/react"
export interface FeaturedArticlesGridProps {
  items: NormalisedArticle[]
  handleTrackingClick: VoidFunction
}

const FeaturedArticlesGrid = ({ items, handleTrackingClick }: FeaturedArticlesGridProps) => {
  const {
    helpers: { ErrorBoundary },
  } = useCore()

  return (
    <Grid templateColumns={["repeat(1, 1fr)", "repeat(4, 1fr)"]} gap={3}>
      <ErrorBoundary>
        {items?.map(item => {
          const props: ArticleGridItemProps = { item, handleTrackingClick }
          return (
            <>
              <Box display={["block", "none"]}>
                <ArticleGridItemMobile key={item?.key} {...props} />
              </Box>
              <Box display={["none", "block"]}>
                <ArticleGridItemDesktop key={item?.key} {...props} />
              </Box>
            </>
          )
        })}
      </ErrorBoundary>
    </Grid>
  )
}

export default FeaturedArticlesGrid
